import { render, staticRenderFns } from "./panel.vue?vue&type=template&id=20bb9838&scoped=true&"
import script from "./panel.vue?vue&type=script&lang=js&"
export * from "./panel.vue?vue&type=script&lang=js&"
import style0 from "./panel.vue?vue&type=style&index=0&id=20bb9838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bb9838",
  null
  
)

export default component.exports